import { Editor } from '../core/Editor';
import { ToolType } from '../types';

export abstract class BaseTool {
  public abstract id: ToolType;
  public abstract name: string;
  public cursor: string = 'default';
  protected editor: Editor;

  constructor(editor: Editor) {
    this.editor = editor;
  }

  public onActivate(): void {}
  public onDeactivate(): void {}

  public onMouseDown(_e: MouseEvent, _canvasX: number, _canvasY: number): void {}
  public onMouseMove(_e: MouseEvent, _canvasX: number, _canvasY: number): void {}
  public onMouseUp(_e: MouseEvent, _canvasX: number, _canvasY: number): void {}
  public onKeyDown(_e: KeyboardEvent): void {}

  public renderOverlay(_ctx: CanvasRenderingContext2D): void {}
}
